module.exports = __webpack_public_path__ + "img/phone.2b23e08a.svg";